import { InjectionToken } from '@angular/core';

export interface PackDocumentAssignmentRequest {
    readonly buildingId: string;
    readonly documentIds: readonly [string, ...string[]];
}

export interface PackDocumentAssignmentLauncher {
    open(
        request: PackDocumentAssignmentRequest
    ): Promise<'cancelled' | 'opened'>;
}

export const BUILDING_PACK_DOCUMENT_ASSIGNMENT =
    new InjectionToken<PackDocumentAssignmentLauncher>(
        'BUILDING_PACK_DOCUMENT_ASSIGNMENT'
    );
